import React from 'react'
import { HolderOutlined } from '@ant-design/icons'
import { DndContext } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Button } from 'antd'
import { isArray } from 'lodash'
import PropTypes from 'prop-types'

const RowContext = React.createContext({})

export const DragButton = () => {
  const { setActivatorNodeRef, listeners } = React.useContext(RowContext)

  return (
    <Button
      icon={<HolderOutlined />}
      ref={setActivatorNodeRef}
      size="small"
      style={{
        cursor: 'move',
      }}
      type="text"
      {...listeners}
    />
  )
}

export const TableRow = (props) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    data: {
      position: isArray(props?.children) ? props.children[0].props.record.position : null,
    },
    id: props['data-row-key'],
  })
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isArray(props?.children) && isDragging
      ? {
        position: 'relative',
        zIndex: 9999,
      }
      : {}),
  }

  const contextValue = React.useMemo(
    () => ({
      listeners,
      setActivatorNodeRef,
    }),
    [setActivatorNodeRef, listeners],
  )

  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  )
}

TableRow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  'data-row-key': PropTypes.string,
}

export const DragAndDrop = ({ children, items, onDragEnd }) => (
  <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
    <SortableContext items={items} strategy={verticalListSortingStrategy}>
      {React.cloneElement(children, {
        components: {
          body: {
            row: TableRow,
          },
        },
      })}
    </SortableContext>
  </DndContext>
)

DragAndDrop.propTypes = {
  children: PropTypes.node.isRequired,
  items: PropTypes.array.isRequired,
  onDragEnd: PropTypes.func.isRequired,
}
